import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ItemGroupList } from './ItemGroupList';
import { volumes } from '../data/content';
export function WhatsIncluded() {
  return <section id="included" className="w-full bg-slate-100 px-5 py-12 sm:py-16" data-id="element-213" data-mp="3u9m9i823r3al">
      <div className="mx-auto max-w-[720px]" data-id="element-214" data-mp="3u7ja4xf27xt7">
        <h2 className="text-center text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-215" data-mp="251wdz9ew1b1">
          What’s Included
        </h2>

        <ol className="mt-7 space-y-4" data-id="element-216" data-mp="uu8pgiq3jyow">
          {volumes.map(volume => <li key={volume.label} className="rounded-lg border border-slate-200 bg-white p-5 sm:p-6" style={{
          borderLeft: `5px solid ${volume.color}`
        }} data-id="element-217" data-mp="us4oa8jl1dsb">
              <div className="flex items-start gap-2.5" data-id="element-218" data-mp="31kyh7sixrdnj">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded" style={{
              backgroundColor: volume.color
            }} aria-hidden="true" data-id="element-219" data-mp="31jdng54g3yqq">
                  <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={4} data-id="element-220" data-mp="1rily9umms5ao" />
                </span>
                <h3 className="text-[1rem] font-extrabold uppercase leading-tight tracking-tight sm:text-[1.15rem]" style={{
              color: volume.color
            }} data-id="element-221" data-mp="26fv6s142fppm">
                  {volume.label} — {volume.title}
                </h3>
              </div>

              <p className="mt-2.5 text-[1rem] font-extrabold leading-snug text-slate-950" data-id="element-222" data-mp="2fe6w7zt74hgh">
                {volume.subtitle}
              </p>

              {volume.description.map(paragraph => <p key={paragraph} className="mt-2 text-[1rem] leading-relaxed text-slate-950" data-id="element-223" data-mp="2k79o83ibriuk">
                  {paragraph}
                </p>)}

              {volume.groups.map(group => <ItemGroupList key={group.intro ?? group.items[0]} group={group} data-id="element-224" data-mp="2u70lue26mdyv" />)}

              {volume.afterText?.map(paragraph => <p key={paragraph} className="mt-3 text-[1rem] leading-relaxed text-slate-950" data-id="element-225" data-mp="3677bhh1xg2zx">
                  {paragraph}
                </p>)}

              {volume.footnote && <p className="mt-4 text-[0.9rem] font-extrabold uppercase leading-snug tracking-tight text-slate-950" data-id="element-226" data-mp="3fyuyn5rgaxvl">
                  {volume.footnote}
                </p>}
            </li>)}
        </ol>
      </div>
    </section>;
}